import React, { useState } from 'react';
import { Eye, Lock, Unlock } from 'lucide-react';
import './LoginScreen.css';

export default function LoginScreen({ setRole }) {
    const [password, setPassword] = useState('');

    const handleAdminLogin = (e) => {
        e.preventDefault();
        if (password === 'ablmasmola') {
            setRole('admin');
        } else {
            window.alert('Contraseña incorrecta');
            setPassword('');
        }
    };

    return (
        <div className="login-screen-layout">
            <div className="login-content-wrapper">
                {/* Logo and Title */}
                <div className="login-logo-container">
                    <img src="/logoabl.png" alt="Logo Liga" className="login-logo" />
                    <h1 className="login-title">
                        Liga Beyblade<br/><span style={{color: 'var(--accent-cyan)'}}>Alicante</span>
                    </h1>
                </div>
                
                {/* Login Modes */}
                <div className="glass-panel login-form-container">
                    {/* Guest Section */}
                    <div className="login-section">
                        <h2 className="login-subtitle" style={{color: 'var(--accent-cyan)'}}>
                            <Eye className="w-6 h-6"/> Modo Jugador
                        </h2>
                        <p className="login-description">
                            Accede libremente para ver torneos, clasificaciones y estadios en tiempo real. Ideal para jugadores.
                        </p>
                        <button onClick={() => setRole('guest')} className="btn btn-primary btn-full-width">
                            Entrar como Jugador
                        </button>
                    </div>

                    {/* Admin Section */}
                    <div className="login-section login-section-divider">
                        <h2 className="login-subtitle" style={{color: 'var(--accent-red)'}}>
                            <Lock className="w-6 h-6"/> Modo Organizador
                        </h2>
                        <form onSubmit={handleAdminLogin} style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
                            <input 
                                type="password" 
                                value={password} 
                                onChange={(e) => setPassword(e.target.value)} 
                                placeholder="Contraseña..." 
                                className="login-input"
                            />
                            <button type="submit" className="btn btn-danger btn-full-width">
                                <Unlock className="w-6 h-6"/> Entrar como Admin
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}